import { render, staticRenderFns } from "./BtnAdicionarCliente.vue?vue&type=template&id=4931dca7&"
import script from "./BtnAdicionarCliente.vue?vue&type=script&lang=js&"
export * from "./BtnAdicionarCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports